import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Label from './label';

const CheckboxContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
`;

const CheckboxUi = styled.label`
  min-width: 16px;
  height: 16px;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  margin-bottom: 0;
  /* @media only screen and (max-width: 1366px) {
    width: 17px;
  } */
  &:after {
    content: '';
    display: block;
    width: 7px;
    height: 4px;
    border-bottom: 2.5px solid #ffffff;
    border-left: 2.5px solid #ffffff;
    transform: rotate(-45deg) scale(0);
    transition: transform ease 0.25s;
    position: absolute;
    top: 4px;
    left: 3px;
    border-radius: 1px;
  }

  ${({ darkMode }) =>
    darkMode
      ? `
		border: 1.5px solid #FFFFFF;
	`
      : `
		border: 1.5px solid #000000;
	`}

  ${({ radio }) =>
    radio &&
    `
		border-radius: 50%;
		&:after{
			content: '';
			display: block;
			border: none;
			width: 12px;
			height: 12px;
			border-radius: 50%;
			background-color: #24BB72;
			top: 2px;
			left: 2px;
		}
	`}
`;

const InputCheckbox = styled.input`
  width: auto;
  opacity: 0.00000001;
  position: absolute;
  &:checked ~ label {
    border: 1.5px solid #24bb72;
    background-color: #24bb72;
    &:after {
      transform: rotate(-46deg) scale(1);
    }
    ${({ type }) =>
      type === 'radio' &&
      `
			background-color: transparent !important;
		`}
  }
`;

export const Checkbox = ({ id, onChange, checked, label, name, darkMode, value, radio }) => {
  const checkboxRef = useRef();

  let newValue;

  const handleChecked = (e) => {
    if (onChange) onChange(e);
  };

  if (typeof value === 'string') {
    newValue = value.toString();
  }

  if (typeof value === 'boolean') {
    if (value === true) {
      newValue = 'true';
    }
    if (value === false) {
      newValue = 'false';
    }
  }

  if (!value && typeof value !== 'boolean') {
    newValue = 'null';
  }

  return (
    <CheckboxContainer>
      <InputCheckbox
        ref={checkboxRef}
        type={!radio ? 'checkbox' : 'radio'}
        id={`checkbox-${id}`}
        onChange={(e) => {
          handleChecked(e);
        }}
        checked={checked}
        name={name}
        value={newValue}
        aria-label={!radio ? 'checkbox' : 'radio'}
      />

      <CheckboxUi darkMode={darkMode} htmlFor={`checkbox-${id}`} radio={radio} />

      {label && (
        <Label darkMode={darkMode} onClick={() => checkboxRef.current.click()}>
          {label}
        </Label>
      )}
    </CheckboxContainer>
  );
};

Checkbox.defaultProps = {
  darkMode: false
};

Checkbox.propTypes = {
  darkMode: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  radio: PropTypes.bool,
  checked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number])
};
